/*!
 * ETAR theme v4.2.4 — Bag (drawer + page): quantities, gift wrap, note, upsell
 * Developed by FACTICIED · https://www.facticied.com
 */
(() => {
  if (window.EtarCart) return;
  const R = () => window.EtarRoutes || {};
  const url = (k, d) => (R()[k] || d).replace(/\.js$/, '');
  const json = { 'Content-Type': 'application/json', Accept: 'application/json' };
  const upsellCache = new Map();

  const Cart = {
    get drawer() { return document.querySelector('et-cart-drawer'); },
    get page() { return document.querySelector('et-cart-page'); },
    get type() { return this.drawer?.dataset.type || 'drawer'; },
    ids() { return Array.from(document.querySelectorAll('[data-cart-section]')).map((el) => el.dataset.cartSection); },

    // Called by product forms after a successful add. Returns true when the toast is not needed.
    afterAdd(cart, btn) {
      const ms = this.fly(btn, cart);
      if (this.type === 'page' && !this.page) { setTimeout(() => { location.href = R().cart || '/cart'; }, ms ? ms + 120 : 0); return true; }
      /* fetch the new bag right away, while the bottle is still flying */
      const fresh = this.refresh();
      if (this.type === 'drawer' && this.drawer) {
        /* open once the bottle has landed AND the new item is in the drawer (never later than 2.5 s) */
        const landed = new Promise((r) => setTimeout(r, ms ? Math.max(0, ms - 120) : 0));
        const cap = new Promise((r) => setTimeout(r, 2500));
        Promise.race([Promise.all([landed, fresh]), cap]).then(() => this.open());
        return true;
      }
      return false;
    },

    // The product photo lifts off the page and flies along an arc into the bag icon,
    // leaving a short gold trail; the bag bumps and its count pops when it lands.
    // Returns the flight time in ms (0 when there is no flight).
    fly(btn, cart) {
      const F = window.EtarFly || { on: true, style: 'arc', ms: 700 };
      if (F.on === false || !btn || !document.body.animate) return 0;
      if (document.documentElement.classList.contains('et-no-motion') || matchMedia('(prefers-reduced-motion: reduce)').matches) return 0;
      const vw = innerWidth, vh = innerHeight;
      const seen = (r) => r && r.width > 0 && r.bottom > 0 && r.top < vh && r.right > 0 && r.left < vw;

      /* where it starts: the photo that belongs to this button */
      const root = btn.closest('[data-fly-root]');
      let src = root && root.querySelector('[data-fly-img]');
      if (!src || !src.getBoundingClientRect().width) {
        const holder = btn.closest('.et-pc, et-product, .et-pp, li, article, [data-fly-root]') || btn.parentElement;
        src = holder && Array.from(holder.querySelectorAll('img')).find((i) => { const r = i.getBoundingClientRect(); return r.width > 30 && r.height > 30; });
      }
      let from = src && src.getBoundingClientRect();
      if (!seen(from)) {
        /* photo is off screen (e.g. sticky bar): start from the button with a small copy of the photo */
        const br = btn.getBoundingClientRect();
        from = { left: br.left + br.width / 2 - 45, top: br.top + br.height / 2 - 60, width: 90, height: 120 };
      }

      /* where it lands: the bag icon, or a small bag that appears in the corner */
      let target = Array.from(document.querySelectorAll('[data-cart-link]')).find((t) => seen(t.getBoundingClientRect()));
      let bubble = null;
      if (!target) {
        bubble = document.createElement('span');
        bubble.className = 'et-fly-bag';
        bubble.innerHTML = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M5 8h14l-1 12.5H6L5 8Z"/><path d="M9 10V6.5a3 3 0 0 1 6 0V10"/></svg><b></b>';
        const prev = cart && typeof cart.item_count === 'number' ? Math.max(0, cart.item_count - 1) : '';
        bubble.querySelector('b').textContent = prev;
        document.body.appendChild(bubble);
        bubble.animate([{ transform: 'scale(.4)', opacity: 0 }, { transform: 'scale(1)', opacity: 1 }], { duration: 300, easing: 'cubic-bezier(.3,1.4,.5,1)', fill: 'both' });
        target = bubble;
      }
      const to = target.getBoundingClientRect();

      /* the flying copy keeps the photo's shape, at most 260 px */
      const fit = Math.min(1, 260 / Math.max(from.width, from.height));
      const w = from.width * fit, h = from.height * fit;
      const sx = from.left + from.width / 2, sy = from.top + from.height / 2;
      const ex = to.left + to.width / 2, ey = to.top + to.height / 2;
      const el = document.createElement('span');
      el.className = 'et-fly';
      Object.assign(el.style, { left: `${sx - w / 2}px`, top: `${sy - h / 2}px`, width: `${w}px`, height: `${h}px` });
      if (src) { const im = document.createElement('img'); im.src = src.currentSrc || src.src; im.alt = ''; el.appendChild(im); } else el.classList.add('is-dot');
      document.body.appendChild(el);

      const ms = Math.max(400, +F.ms || 700);
      const arc = F.style !== 'simple';
      /* a curve that rises before it drops into the bag */
      const cx = sx + (ex - sx) * 0.55, cy = Math.min(sy, ey) - (arc ? Math.min(220, Math.abs(ex - sx) * 0.25 + 90) : 0);
      const at = (t) => { const u = 1 - t; return [u * u * sx + 2 * u * t * cx + t * t * ex, u * u * sy + 2 * u * t * cy + t * t * ey]; };
      const ease = (t) => (t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2);
      const end = Math.max(0.08, Math.min(0.5, 30 / Math.max(w, h)));
      const frames = [];
      for (let i = 0; i <= 28; i++) {
        const t = i / 28, e = ease(t), [x, y] = at(e);
        const lift = t < 0.12 ? 1 + (t / 0.12) * 0.06 : 1.06 - (1.06 - end) * Math.pow((t - 0.12) / 0.88, 0.9);
        const rot = arc ? Math.sin(e * Math.PI) * -12 : 0;
        frames.push({ transform: `translate(${(x - sx).toFixed(1)}px,${(y - sy).toFixed(1)}px) rotate(${rot.toFixed(1)}deg) scale(${lift.toFixed(3)})`, opacity: t > 0.9 ? 1 - (t - 0.9) * 7 : 1, offset: t });
      }
      el.animate(frames, { duration: ms, easing: 'linear', fill: 'forwards' });

      /* gold trail */
      if (arc) {
        for (let i = 1; i <= 9; i++) {
          const t = 0.18 + i * 0.075; if (t > 0.92) break;
          const [x, y] = at(ease(t));
          const d = document.createElement('i');
          d.className = 'et-fly-spark';
          d.style.left = `${x}px`; d.style.top = `${y}px`;
          document.body.appendChild(d);
          d.animate([{ transform: 'translate(-50%,-50%) scale(0)', opacity: 0 }, { transform: 'translate(-50%,-50%) scale(1)', opacity: 0.9, offset: 0.25 }, { transform: 'translate(-50%,-50%) scale(.2)', opacity: 0 }],
            { duration: 620, delay: t * ms, easing: 'ease-out', fill: 'both' }).onfinish = () => d.remove();
        }
      }

      setTimeout(() => {
        el.remove();
        /* landing: ring, bump and count pop */
        const ring = document.createElement('i');
        ring.className = 'et-fly-ring';
        ring.style.left = `${ex}px`; ring.style.top = `${ey}px`;
        document.body.appendChild(ring);
        ring.animate([{ transform: 'translate(-50%,-50%) scale(.3)', opacity: 0.9 }, { transform: 'translate(-50%,-50%) scale(2.4)', opacity: 0 }], { duration: 600, easing: 'ease-out' }).onfinish = () => ring.remove();
        target.classList.remove('et-bump'); void target.offsetWidth; target.classList.add('et-bump');
        setTimeout(() => target.classList.remove('et-bump'), 650);
        document.querySelectorAll('[data-cart-count]').forEach((c) => { c.classList.remove('et-pop'); void c.offsetWidth; c.classList.add('et-pop'); });
        if (bubble) {
          if (cart && typeof cart.item_count === 'number') bubble.querySelector('b').textContent = cart.item_count;
          setTimeout(() => bubble.animate([{ opacity: 1, transform: 'scale(1)' }, { opacity: 0, transform: 'scale(.6)' }], { duration: 300, fill: 'forwards' }).onfinish = () => bubble.remove(), 1300);
        }
      }, ms);
      return ms;
    },

    open() { this.drawer?.open(); },
    close() { this.drawer?.close(); },

    render(sections) {
      if (!sections) return;
      Object.entries(sections).forEach(([id, html]) => {
        const host = document.querySelector(`[data-cart-section="${id}"]`);
        if (!host || !html) return;
        const fresh = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-cart-region]');
        const cur = host.querySelector('[data-cart-region]');
        if (!fresh || !cur) return;
        const scroller = cur.querySelector('.et-bag__main'), top = scroller ? scroller.scrollTop : 0;
        const noteOpen = cur.querySelector('.et-bag__note')?.open;
        cur.replaceWith(fresh);
        const ns = fresh.querySelector('.et-bag__main'); if (ns) ns.scrollTop = top;
        const note = fresh.querySelector('.et-bag__note'); if (note && noteOpen) note.open = true;
        host.dispatchEvent(new CustomEvent('et:cart:rendered', { bubbles: true }));
        // Gift wrap left alone in the bag: take it out too
        if (fresh.dataset.giftOrphan) this.change(Number(fresh.dataset.giftOrphan), 0, host);
      });
    },

    emit(cart) {
      if (cart && typeof cart.item_count === 'number') document.dispatchEvent(new CustomEvent('et:cart:updated', { detail: cart }));
    },

    async refresh() {
      const ids = this.ids();
      if (!ids.length) return;
      try {
        const res = await fetch(`${location.pathname}?sections=${ids.join(',')}`, { headers: { Accept: 'application/json' } });
        if (res.ok) this.render(await res.json());
      } catch (e) { /* offline: keep what is shown */ }
    },

    async post(path, body) {
      const res = await fetch(`${path}.js`, { method: 'POST', headers: json, body: JSON.stringify({ ...body, sections: this.ids().join(','), sections_url: location.pathname }) });
      const data = await res.json().catch(() => ({}));
      if (!res.ok) { const err = new Error(data.description || data.message || 'error'); err.data = data; throw err; }
      return data;
    },

    async change(line, quantity, host) {
      const li = host?.querySelector(`[data-line="${line}"]`);
      li?.classList.add('is-busy');
      if (quantity === 0 && li) li.classList.add('is-leaving');
      try {
        const [data] = await Promise.all([this.post(url('cartChange', '/cart/change'), { line, quantity }), new Promise((r) => setTimeout(r, quantity === 0 ? 380 : 0))]);
        this.render(data.sections);
        this.emit(data);
      } catch (e) {
        li?.classList.remove('is-busy', 'is-leaving');
        this.lineError(host, line, e.message !== 'error' ? e.message : host?.dataset.error);
        const input = li?.querySelector('[data-qty-input]'); if (input) input.value = input.defaultValue;
      }
    },

    lineError(host, line, msg) {
      const err = host?.querySelector(`[data-line="${line}"] [data-line-err]`);
      if (!err || !msg) return;
      err.textContent = msg; err.hidden = false;
    },

    flash(host, msg) {
      const main = host?.querySelector('.et-bag__main');
      if (!main || !msg) return;
      const p = document.createElement('p');
      p.className = 'et-bag__flash'; p.setAttribute('role', 'alert'); p.textContent = msg;
      main.prepend(p);
      setTimeout(() => p.remove(), 5000);
    },

    async add(items, host) {
      try {
        const data = await this.post(url('cartAdd', '/cart/add'), { items });
        this.render(data.sections);
        const cart = await (await fetch(`${url('cart', '/cart')}.js`, { headers: { Accept: 'application/json' } })).json();
        this.emit(cart);
      } catch (e) {
        await this.refresh();
        this.flash(host, e.message !== 'error' ? e.message : host?.dataset.error);
      }
    },

    note(text) {
      clearTimeout(this.noteT);
      this.noteT = setTimeout(() => {
        fetch(`${url('cart', '/cart')}/update.js`, { method: 'POST', headers: json, body: JSON.stringify({ note: text }) }).catch(() => {});
      }, 500);
    },
  };
  window.EtarCart = Cart;

  // Shared behaviour for the drawer and the page
  const bind = (host, signal) => {
    const orphan = host.querySelector('[data-gift-orphan]');
    if (orphan) setTimeout(() => Cart.change(Number(orphan.dataset.giftOrphan), 0, host), 0);
    host.addEventListener('click', (e) => {
      const q = e.target.closest('[data-qty]');
      if (q && host.contains(q)) {
        const li = q.closest('[data-line]');
        const max = Number(li.querySelector('[data-qty-input]')?.max || 0);
        const n = Number(q.dataset.qty);
        if (max && n > max) return;
        const input = li.querySelector('[data-qty-input]');
        if (input && n > 0) { input.value = n; input.closest('.et-bag__qty')?.classList.add('is-roll'); }
        Cart.change(Number(li.dataset.line), Math.max(0, n), host);
      }
    }, { signal });
    host.addEventListener('change', (e) => {
      const t = e.target;
      if (t.matches('[data-qty-input]')) {
        const li = t.closest('[data-line]');
        const n = Math.max(0, parseInt(t.value, 10) || 0);
        Cart.change(Number(li.dataset.line), n, host);
      } else if (t.matches('[data-gift]')) {
        t.closest('.et-bag__gift')?.classList.toggle('is-on', t.checked);
        t.disabled = true;
        if (t.checked) Cart.add([{ id: Number(t.dataset.gift), quantity: 1 }], host);
        else Cart.change(Number(t.dataset.giftLine), 0, host);
      } else if (t.matches('[data-terms]')) {
        host.querySelectorAll('[data-checkout]').forEach((b) => { b.disabled = !t.checked; });
      }
    }, { signal });
    host.addEventListener('input', (e) => { if (e.target.matches('[data-note]')) Cart.note(e.target.value); }, { signal });
    host.addEventListener('submit', (e) => {
      const f = e.target.closest('[data-up-form]');
      if (!f) return;
      e.preventDefault();
      f.querySelector('button')?.classList.add('is-loading');
      const fd = new FormData(f);
      Cart.add([{ id: Number(fd.get('id')), quantity: Number(fd.get('quantity') || 1) }], host);
    }, { signal });
  };

  class EtCartDrawer extends HTMLElement {
    connectedCallback() {
      this.ac = new AbortController();
      const signal = this.ac.signal;
      this.panel = this.querySelector('.et-cd__panel');
      bind(this, signal);
      this.addEventListener('click', (e) => { if (e.target.closest('[data-cd-close]')) this.close(); }, { signal });
      this.addEventListener('et:cart:rendered', () => this.upsell(), { signal });
      document.addEventListener('keydown', (e) => { if (e.key === 'Escape' && this.classList.contains('is-open')) this.close(); }, { signal });
      document.addEventListener('click', (e) => {
        const link = e.target.closest('[data-cart-link]');
        if (!link || this.dataset.type !== 'drawer') return;
        e.preventDefault();
        this.open();
      }, { signal });
    }

    disconnectedCallback() { this.ac?.abort(); this.untrap?.(); }

    open() {
      if (this.classList.contains('is-open')) return;
      this.last = document.activeElement;
      this.classList.add('is-open');
      window.Etar?.lockScroll(true);
      this.untrap = window.Etar?.trapFocus(this.panel);
      setTimeout(() => this.querySelector('.et-bag__x')?.focus({ preventScroll: true }), 120);
      this.upsell();
    }

    close() {
      if (!this.classList.contains('is-open')) return;
      this.classList.remove('is-open');
      this.untrap?.(); this.untrap = null;
      window.Etar?.lockScroll(false);
      if (this.last && this.last.focus) this.last.focus({ preventScroll: true });
    }

    async upsell() {
      const slot = this.querySelector('[data-upsell]');
      if (!slot || !this.classList.contains('is-open')) return;
      const src = slot.dataset.upsell;
      try {
        let html = upsellCache.get(src);
        if (html === undefined) {
          const res = await fetch(src);
          const doc = new DOMParser().parseFromString(await res.text(), 'text/html');
          html = doc.querySelector('[data-upsell-list]')?.innerHTML.trim() || '';
          upsellCache.set(src, html);
        }
        if (!html || !slot.isConnected) return;
        slot.innerHTML = html;
        slot.hidden = false;
      } catch (e) { slot.hidden = true; }
    }
  }

  class EtCartPage extends HTMLElement {
    connectedCallback() { this.ac = new AbortController(); bind(this, this.ac.signal); }
    disconnectedCallback() { this.ac?.abort(); }
  }

  // One tap add from any product card: <button data-qa="variant id">
  const toast = (msg, link) => {
    let t = document.querySelector('.et-qa-toast');
    if (!t) { t = document.createElement('div'); t.className = 'et-qa-toast'; t.setAttribute('role', 'status'); document.body.appendChild(t); }
    t.textContent = msg;
    if (link) { const a = document.createElement('a'); a.href = R().cart || '/cart'; a.textContent = (window.EtarText || {}).view || 'View bag'; t.appendChild(a); }
    requestAnimationFrame(() => t.classList.add('is-on'));
    clearTimeout(t._t); t._t = setTimeout(() => t.classList.remove('is-on'), 3000);
  };
  document.addEventListener('click', async (e) => {
    const btn = e.target.closest('button[data-qa]');
    if (!btn || btn.disabled || !btn.dataset.qa) return;
    e.preventDefault();
    btn.classList.add('is-loading');
    const T = window.EtarText || {};
    try {
      const res = await fetch(`${url('cartAdd', '/cart/add')}.js`, { method: 'POST', headers: json, body: JSON.stringify({ items: [{ id: Number(btn.dataset.qa), quantity: 1 }] }) });
      if (!res.ok) { let d = {}; try { d = await res.json(); } catch (x) {} throw new Error(d.description || T.error || 'Error'); }
      const cart = await (await fetch(`${url('cart', '/cart')}.js`, { headers: { Accept: 'application/json' } })).json();
      document.dispatchEvent(new CustomEvent('et:cart:updated', { detail: cart }));
      btn.classList.add('is-done'); setTimeout(() => btn.classList.remove('is-done'), 1400);
      if (!Cart.afterAdd(cart, btn)) toast(T.added || 'Added', true);
    } catch (err) { toast(err.message || T.error || 'Error'); }
    finally { btn.classList.remove('is-loading'); }
  });

  if (!customElements.get('et-cart-drawer')) customElements.define('et-cart-drawer', EtCartDrawer);
  if (!customElements.get('et-cart-page')) customElements.define('et-cart-page', EtCartPage);
})();
